import React, { useState } from 'react';
import BrowseTab from './BrowseTab';
import StructureTab from './StructureTab';
import SqlEditor from './Editor';
import '../css/ObjectsTab.css';
import DbUpdates from './DbUpdates';
import SearchTab from './SearchTab';
import ExportTab from './ExportTab';
import ImportTab from './ImportTab';

const tabs = [
  'Browse',
  'Structure',
  'SQL',
  'DB Updates',
  'Search',
  'Export',
  'Import',
];

function ObjectTabs({ selectedObject }) {
  const [activeTab, setActiveTab] = useState('Browse');

  if (!selectedObject) return <div className="tabs">No object selected.</div>;
  const handleTab = (tab) => {
    if (tab === 'DB Updates') {
      if (
        window.confirm(
          'Are you sure to update Database with last version of Node Updates?'
        )
      ) {
        setActiveTab(tab);
      }
    } else {
      setActiveTab(tab);
    }
  };

  const { name, type } = selectedObject;

  return (
    <div className="container-fluid">
      <div className="py-3">
        <h4>
          {name}{' '}
          <small className="text-muted" style={{ fontSize: '0.8em' }}>
            ({type})
          </small>
        </h4>
      </div>

      {/* Navbar-style full-width tabs */}
      <ul className="nav nav-tabs mb-3">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab}>
            <button
              className={`nav-link ${activeTab === tab ? 'active' : ''}`}
              onClick={() => handleTab(tab)}
            >
              {tab}
            </button>
          </li>
        ))}
      </ul>

      <div className="tab-content p-3 border rounded bg-white shadow-sm">
        {activeTab === 'Browse' && <BrowseTab table={name} />}
        {activeTab === 'Structure' && <StructureTab table={name} />}
        {activeTab === 'SQL' && <SqlEditor />}
        {activeTab === 'DB Updates' && <DbUpdates />}

        {activeTab === 'Search' && <SearchTab table={name} />}
        {activeTab === 'Export' && <ExportTab table={name} />}
        {activeTab === 'Import' && <ImportTab table={name} />}
      </div>
    </div>
  );
}

export default ObjectTabs;
